export default {
  key: 'system--preview',
  routes: [/^\/preview(\/|$)/],
  i18nNamespaces: ['preview'],
  app:     () => import('./app.js').then(m => m.default),
  context: () => import('./context.js').then(m => m.default),
}
